
import React from 'react';
import { useLocation, Navigate, useNavigate } from 'react-router-dom';
import PersonalizationFlow from '@/components/PersonalizationFlow';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

const Personalization = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { painPoint, fromQuiz } = location.state || {};

  // Redirect if not from pain quiz
  if (!fromQuiz || !painPoint) {
    return <Navigate to="/app" replace />;
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-purple-50 via-blue-50 to-indigo-100">
      {/* Header with back button */}
      <div className="sticky top-0 z-50 bg-white/80 backdrop-blur-sm border-b border-gray-200">
        <div className="max-w-2xl mx-auto px-6 py-4 flex items-center">
          <Button 
            variant="ghost" 
            onClick={() => navigate('/app')}
            className="mr-4"
          >
            <ArrowLeft className="h-4 w-4 mr-2" />
            Back to Home
          </Button>
          <div className="flex-1 text-center">
            <h1 className="font-semibold text-gray-800">Personal Setup</h1>
            <p className="text-sm text-gray-600">Step-by-step customization</p>
          </div>
        </div>
      </div>
      
      <PersonalizationFlow />
    </div>
  );
};

export default Personalization;
